import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { setCookie } from '../../utils/cookie';
import CryptoJS from 'crypto-js';

const initialState = {
    status: null,
    message: null,
    customerId: null,
    // appLimit: null,
    storesList: null
}


export const getSaasConfig = createAsyncThunk("getSaasConfig", async (custId) => {
    try {
        const response = await fetch(`/api/getSaasConfig/${custId}`, {
            method: "GET"
        })
        if (!response.ok) {
            throw new Error("Failed to fetch data");
        }
        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
});


const getSaasConfigSlice = createSlice({
    name: "getSaasConfig",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(getSaasConfig.pending, (state) => {
            state.status = "loading"
        });
        builder.addCase(getSaasConfig.fulfilled, (state, action) => {
            state.status = action.payload.data.status
            state.customerId = action.payload.data.data.struCustomerId
            // state.appLimit = action.payload.data.data.appLimit
            state.storesList = action.payload.data.data.configurations
            // Encrypt the response data
            const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(action.payload.data.data), 'fc4db694c037f966e0bb694329460460').toString();
            setCookie("struInf", encryptedData)
        });
        builder.addCase(getSaasConfig.rejected, (state) => {
            state.status = "error"
            state.message = "PIM connection failed"
        });
    }
})

export default getSaasConfigSlice.reducer